import React, { useState } from 'react';

const MessagesContext = React.createContext();

const MessagesProvider = (props) => {
    const INITIAL_STATE = {
        messages: []
    }

    const [messagesState, setMessagesState] = useState(INITIAL_STATE);
        
    const getMessages = () => {
        return messagesState.messages;
    }

    const addMessage = (type, message) => {
        setMessagesState({ messages: [ ...messagesState.messages, { type: type, message: message }] });
    }

    const removeMessage = (message) => {
        setMessagesState({ messages: messagesState.messages.filter(x => x !== message) });
    }
    return (
        <MessagesContext.Provider 
            value={{ 
                getMessages: getMessages,
                addMessage: addMessage,
                removeMessage: removeMessage
            }} >
            {props.children}
        </MessagesContext.Provider>
    )
}

const MessagesConsumer = MessagesContext.Consumer;

const MessageTypes = Object.freeze({
    Error: "danger",
    Info: "warning",
    Success: "success"
});

export { MessagesProvider, MessagesConsumer, MessageTypes };